import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Test from "./Test";
import About from "./About";
import Model from "./Model";



export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        
          <Route index element={<Home />} />
          <Route path="test" element={<Test />} />
          <Route path="about" element={<About />} />
          <Route path="model" element={<Model />} />
     
      </Routes>
    </BrowserRouter>
  );
}